<!--
 * @LastEditors: 八千
 -->
<template>
  <div>
    <div id="newHeader" class="mobile" style="height: 55px"></div>
    <div class="container1920sub relative newheader">
      <div class="row">
        <div class="one half mobile">
          <a>
            <img
              @click="handleRouter('home_en')"
              class="fn-left logo-csvw"
              src="data:image/png;base64,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"
            />
          </a>
        </div>
        <div class="one half mobile">
          <!-- <img class="fn-right hamburger hide-on-ipad  hide-on-desktop hide-on-ipad" src="data:image/gif;base64,R0lGODlhKgAhAIABAGFhYf///yH5BAEAAAEALAAAAAAqACEAAAJXhB95y+3fUoC0Qmmzxrpf5YUMJ2bSiabqyrbuC8cyG4GlSN5erm9275sAO7zhYoZMKpdMWU1otBSjjil19LtWs1ostNsMi8fk1LP7+aKP3DXAioaD29ECADs="
          alt="">-->
          <button
            class="fn-right hamburger hide-on-ipad hide-on-desktop hide-on-ipad btn-nav"
          >
            <span class="icon-bar top"></span>
            <span class="icon-bar middle"></span>
            <span class="icon-bar bottom"></span>
          </button>
          <div
            class="fn-right hamburger hide-on-ipad hide-on-desktop hide-on-ipad"
            style="
              background: #9a9a9a;
              color: #fff;
              line-height: 22px;
              text-align: center;
              cursor: pointer;
              width: 40px;
              border-radius: 4px;
              float: right;
              margin-top: 15px;
            "
          >
            <a
              href="https://www.csvw.com/csvw-website/module/index.html"
              style="color: #ffffff"
            >
              CN
            </a>
          </div>
          <div
            class="fn-right hide-on-ipad hide-on-small-tablet hide-on-mobile"
          >
            <div class="search" style="float: left; margin-right: 20px">
              <div class="icon-sou"></div>
              <input
                style="background-size: 15px 16px"
                type="text"
                placeholder="新车 纯电 智能 销量 权益"
                onfocus="this.placeholder=''"
                onblur="this.placeholder='新车 纯电 智能 销量 权益'"
                class="icon-search"
                v-model="searchValue"
                @keyup.enter="handleSearch"
              />
            </div>
            <div class="search" style="float: left; width: 40px">
              <div
                class="icon-sou"
                style="
                  background: #9a9a9a;
                  color: #fff;
                  line-height: 22px;
                  text-align: center;
                  cursor: pointer;
                  width: 40px;
                  border-radius: 4px;
                "
              >
                <a
                  href="https://www.csvw.com/csvw-website/module/index.html"
                  style="color: #ffffff"
                >
                  CN
                </a>
              </div>
              <input
                type="text"
                placeholder
                class="icon-search"
                style="opacity: 0; width: 0"
              />
            </div>
          </div>
        </div>
      </div>

      <nav
        class="nav lv2-nav-flag hide-on-ipad hide-on-small-tablet hide-on-mobile hide"
        title
        style="display: block"
      >
        <ul class="oneul">
          <li class="lilv1">
            <button @click="handleRouter('home_en')">
              <span>About Us</span>
            </button>
            <ul class="lilv1-next subnavul01">
              <li @click="handleRouter2(0)"><a>Enterprise Overview</a></li>
              <li @click="handleRouter2(2)"><a>Corporate Culture</a></li>
              <li @click="handleRouter2(1)"><a>Plant Layout</a></li>
            </ul>
          </li>
          <li class="lilv1">
            <button @click="handleRouter3(-1)">
              <span>Brands & Models</span>
            </button>
            <ul class="lilv1-next subnavul02">
              <li @click="handleRouter3(index)" v-for="(item, index) in selectList" :key="index"><a>{{item.brand_name}}</a></li>
            </ul>
          </li>
        </ul>
      </nav>
      <div class="blackmask"></div>
    </div>

    <div
      class="full_width border1b_e1e1e1 absolute niubnav hide-on-desktop hide-on-ipad"
    >
      <ul>
        <li class="lil1 lil1hassub rolemenu">
          <a href="javascript:;" style="background-position-x: 75%">
            <span @click="handleRouter('home_en')">About Us</span>
          </a>
          <ul class="subnav subnav1">
            <li @click="handleRouter2(0)"><a>Enterprise Overview</a></li>
            <li @click="handleRouter2(2)"><a>Corporate Culture</a></li>
            <li @click="handleRouter2(1)"><a>Plant Layout</a></li>
          </ul>
        </li>
        <li class="lil1 lil1hassub rolemenu">
          <a href="javascript:;" style="background-position-x: 75%">
            <span @click="handleRouter3(0)">Brands & Models</span>
          </a>
          <ul class="subnav subnav2">
            <li @click="handleRouter3(index)" v-for="(item, index) in selectList" :key="index"><a>{{item.brand_name}}</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { csvw_url } from "./config";
export default {
  data() {
    return {
      searchValue: "",
      selectList: []
    };
  },
  mounted() {
    this.mobileMenu();
    this.pcMenu();
    this.getList();
  },
  methods: {
    handleSearch() {
      let search = escape(this.searchValue.trim());
      search && window.open(`/qiye/search_en?search=${search}`, "_blank");
    },
    handleRouter(val) {
      this.$router.replace({ name: val });
    },
    handleRouter2(index) {
      // this.$router.replace({ name: "about_en", query: { index } });
      window.open(`/qiye/about_en?index=${index}`, "_self");
    },
    handleRouter3(index) {
      // this.$router.replace({ name: "brand_en", query: { index } });
      window.open(`/qiye/brand_en?index=${index}`, "_self");
    },
    mobileMenu() {
      $(".hamburger").on("click", function () {
        $(this).toggleClass("animated");
        $(".niubnav").toggle();
      });
      $(".lil1hassub > a").on("click", function () {
        $(this).siblings("ul").slideToggle();
      });
    },

    pcMenu() {
      var sf = this;
      $(".nav .oneul .lilv1")
        .not(".lilv1index, .lilv1tk")
        .mouseenter(function () {
          //sf.disableScroll();
          $(".blackmask").show();
          $(this).children().eq(1).show();
        })
        .mouseleave(function () {
          //sf.enableScroll();
          $(".blackmask").hide();
          $(this).children().eq(1).hide();
        });
    },

    getList() {
      this.selectList = [];
      this.axios
        .get(`${csvw_url}/front/news/tcEngCarTypeBrand/list`)
        .then((res) => {
          let list = res.data.data;
          this.selectList = list;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    },
    disableScroll: function () {
      var sf = this;
      if (window.addEventListener)
        // older FF
        window.addEventListener("DOMMouseScroll", sf.preventDefault, false);
      window.onwheel = sf.preventDefault; // modern standard
      window.onmousewheel = document.onmousewheel = sf.reventDefault; // older browsers, IE
      window.ontouchmove = sf.preventDefault; // mobile
      document.onkeydown = sf.preventDefaultForScrollKeys;
    },

    enableScroll: function () {
      var sf = this;
      if (window.removeEventListener)
        window.removeEventListener("DOMMouseScroll", sf.preventDefault, false);
      window.onmousewheel = document.onmousewheel = null;
      window.onwheel = null;
      window.ontouchmove = null;
      document.onkeydown = null;
    },
  },
};
</script>
<style scoped src="../assets/less/about.css"></style>
<style scoped src="../assets/less/groundwork.css"></style>
<style scoped src="../assets/less/main.css"></style>
<style scoped src="../assets/less/swiper.min.css"></style>